import { createStyles, makeStyles, Typography } from '@material-ui/core';
import React, { ReactNode } from 'react';
import { EmptyCamera } from '../Icons';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      textAlign: 'center',
      maxWidth: '400px',
      margin: '40px auto',
    },
    iconSize: {
      marginBottom: '20px',
      fontSize: '64px',
    },
  }),
);

export const EmptyCameraNotification = ({ children }: { children: ReactNode }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <EmptyCamera className={classes.iconSize} />
      <Typography>{children}</Typography>
    </div>
  );
};
